export const ENDPOINTS_AUTH = {
  register: "/auth/register",
  login: "/auth/login",
  google: "/auth/google",
  devLogin: "/auth/dev-login",
  logout: "/auth/logout",
  me: "/auth/me",
  lookupEmail: "/auth/lookup-email",
  changePassword: "/auth/change-password",
  twofaSetup: "/auth/2fa/setup",
  twofaVerify: "/auth/2fa/verify",
  twofaDisable: "/auth/2fa/disable",
  sessions: "/auth/sessions",
  logoutAll: "/auth/sessions/logout-all",
  notifications: "/auth/notifications",
  workspace: "/auth/workspace",
  compliance: "/auth/compliance",
  export: "/auth/export",
  deleteMe: "/auth/me",
  walletNonce: "/auth/wallet/nonce",
  walletLink: "/auth/wallet/link",
  walletUnlink: "/auth/wallet",
};

export const ENDPOINTS_CONTRACTS = {
  list: "/contracts",
  create: "/contracts",
  detail: (id) => `/contracts/${id}`,
  addMilestone: (id) => `/contracts/${id}/milestones`,
  accept: (id) => `/contracts/${id}/accept`,
  decline: (id) => `/contracts/${id}/decline`,
};

export const ENDPOINTS_MILESTONES = {
  fund: (id) => `/milestones/${id}/fund`,
  fundConfirm: (id) => `/milestones/${id}/fund/confirm`,
  remindFunding: (id) => `/milestones/${id}/remind-funding`,
  revise: (id) => `/milestones/${id}/revise`,
  reviseApprove: (id) => `/milestones/${id}/revise/approve`,
  reviseDecline: (id) => `/milestones/${id}/revise/decline`,
  reviseWithdraw: (id) => `/milestones/${id}/revise/withdraw`,
  reviseAuthorize: (id) => `/milestones/${id}/revise/authorize`,
  reviseConfirm: (id) => `/milestones/${id}/revise/confirm`,
  claimConfirm: (id) => `/milestones/${id}/claim/confirm`,
  cancel: (id) => `/milestones/${id}/cancel`,
  submit: (id) => `/milestones/${id}/submit`,
  approve: (id) => `/milestones/${id}/approve`,
  requestChanges: (id) => `/milestones/${id}/request-changes`,
  release: (id) => `/milestones/${id}/release`,
  dispute: (id) => `/milestones/${id}/dispute`,
  invoice: (id) => `/milestones/${id}/invoice`,
};

export const ENDPOINTS_DISPUTES = {
  list: "/disputes",
  create: "/disputes",
  detail: (id) => `/disputes/${id}`,
  resolve: (id) => `/disputes/${id}/resolve`,
  cancel: (id) => `/disputes/${id}/cancel`,
};

export const ENDPOINTS_INVOICES = {
  list: "/invoices",
  create: "/invoices",
  detail: (id) => `/invoices/${id}`,
  send: (id) => `/invoices/${id}/send`,
  cancel: (id) => `/invoices/${id}/cancel`,
  pay: (id) => `/invoices/${id}/pay`,
  fundConfirm: (id) => `/invoices/${id}/fund/confirm`,
  claim: (id) => `/invoices/${id}/claim`,
  claimConfirm: (id) => `/invoices/${id}/claim/confirm`,
  dispute: (id) => `/invoices/${id}/dispute`,
};

export const ENDPOINTS_FUNDING = {
  list: "/funding-methods",
  create: "/funding-methods",
  setDefault: (id) => `/funding-methods/${id}/default`,
  remove: (id) => `/funding-methods/${id}`,
};

export const ENDPOINTS_PAYOUT = {
  list: "/payout-methods",
  create: "/payout-methods",
  verify: (id) => `/payout-methods/${id}/verify`,
  setDefault: (id) => `/payout-methods/${id}/default`,
  remove: (id) => `/payout-methods/${id}`,
};

export const ENDPOINTS_TEAM = {
  list: "/team/invites",
  create: "/team/invites",
  revoke: (id) => `/team/invites/${id}`,
};

export const ENDPOINTS_WALLET = {
  get: "/wallet",
};

export const ENDPOINTS_FAUCET = {
  drip: "/faucet",
};

export const ENDPOINTS_PRICE = {
  kub: "/price",
};

export const ENDPOINTS_TRANSACTIONS = {
  list: "/transactions",
};

export const ENDPOINTS_NOTIFICATIONS = {
  list: "/notifications",
  read: (id) => `/notifications/${id}/read`,
  readAll: "/notifications/read-all",
};

export const ENDPOINTS_DASHBOARD = {
  get: "/dashboard",
};

export const ENDPOINTS_KARMA = {
  me: "/karma/me",
  ledger: "/karma/ledger",
  byUser: (id) => `/users/${id}/karma`,
};

export const ENDPOINTS_REWARDS = {
  list: "/rewards",
  detail: (id) => `/rewards/${id}`,
  redeem: (id) => `/rewards/${id}/redeem`,
  redemptions: "/redemptions",
};

export const ENDPOINTS_ADMIN = {
  users: "/admin/users",
  contracts: "/admin/contracts",
};

export const ENDPOINTS_LEADERBOARD = {
  list: "/leaderboard",
};
